module.exports = __webpack_public_path__ + "assets/img/nordic_head.9ee76c88.svg";